import { parentAccountApi } from '@atheneum/api'
import { extendObservable } from 'mobx'
import moment from 'moment'

class ParentMetricStore {
  constructor () {
    extendObservable(this, {
      loading: false,
      id: null,
      type: 'account',
      month: '',
      allTime: false,
      metrics: []
    })
  }

  fetch = async () => {
    this.loading = true
    const metrics = await parentAccountApi.fetchParentMetric({
      id: this.id,
      type: this.type,
      // If allTime is selected don't send month
      month: !this.allTime && moment(this.month).format('YYYY-MM')
    })

    this.metrics.replace(metrics)
    this.loading = false
  }

  setVal = (key, val) => {
    if (this.loading) return // ignore filter changes while waiting for response to avoid race conditions
    this[key] = val
    this.fetch()
  }

  init = id => {
    this.type = 'account'
    this.id = id
    this.month = moment()
      .add(-1, 'year')
      .format('YYYY-MM')
    this.fetch()
  }
}

export default ParentMetricStore
